export const DEFAULT_FAVORITE_CELL_ICON_BUTTON_PROPS = {
  fontSize: 'large',
};
